/* eslint-disable no-unused-vars */

import Menu from '../utils/menu';
import { Component } from '../core/component';

export class Header extends Component {
    constructor() {
        super();
        this.selector = '[data-header]';
    }

    init() {
        let globalMenu = null;
        const html = document.getElementsByTagName('html')[0];
        const header = document.querySelector('[data-header]');
        const menuToggle = document.querySelector('[data-header-hamburger]');
        const groupToggles = document.querySelectorAll('[data-menugroup-toggle]');
        const body = document.getElementsByTagName('body')[0];
        const scrollUp = 'scroll-up';
        const scrollDown = 'scroll-down';
        let lastScroll = 0;

        window.addEventListener('scroll', () => {
            const currentScroll = window.pageYOffset;

            if (currentScroll <= (header.clientHeight / 2)) {
                body.classList.remove(scrollUp);
                return;
            }

            if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
                // down
                body.classList.remove(scrollUp);
                body.classList.add(scrollDown);
            } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
                // up
                body.classList.remove(scrollDown);
                body.classList.add(scrollUp);
            }

            lastScroll = currentScroll;
        });

        // initialize global menu
        globalMenu = new Menu(menuToggle);

        // initialize group menus
        groupToggles.forEach((toggle) => {
            const group = new Menu(toggle);
        });

        globalMenu.on('open', () => {
            html.classList.add('has-open-menu');
        });

        globalMenu.on('close', () => {
            html.classList.remove('has-open-menu');
        });
    }
}
